import {
  Box,
  Button,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  Modal,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ModalHeader } from "../../common/modalHeader";
import { addReduceReason, getReduceStockDetails } from "./stockApi";
import CloseIcon from "@mui/icons-material/Close";

export const EditStockModal = ({ open, setOpen, data, onUpdate }) => {
  const [formData, setFormData] = useState({
    rawMaterialId: 0,
    quantityToReduce: 0,
    reason: "",
  });

  useEffect(() => {
    if (open && data?.rawMaterialId) {
      getReduceStockDetails(
        { rawMaterialId: data.rawMaterialId, page: 1, pageSize: 1000 },
        (response) => {
          console.log("API Response:", response);

          // Check if response succeeded and has data
          if (response?.succeeded && response.data?.length > 0) {
            const latestRecord = response.data[0];
            console.log("Latest Record:", latestRecord);

            setFormData({
              rawMaterialId: data.rawMaterialId,
              quantityToReduce: latestRecord.quantity || 0,
              reason: latestRecord.reason || "",
            });
          } else {
            setFormData({
              rawMaterialId: data.rawMaterialId,
              quantityToReduce: 0,
              reason: "",
            });
          }
        }
      );
    } else {
      setFormData({
        rawMaterialId: 0,
        quantityToReduce: 0,
        reason: "",
      });
    }
  }, [open, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "quantityToReduce" ? parseFloat(value) || 0 : value,
    }));
  };

  const handleSubmit = () => {
    console.log("Submitting:", formData);
    addReduceReason(formData, () => {
      setFormData({
        rawMaterialId: 0,
        quantityToReduce: 0,
        reason: "",
      });
      setOpen(false);
      if (onUpdate) onUpdate();
    });
    getReduceStockDetails(
      { rawMaterialId: data.rawMaterialId, page: 1, pageSize: 1000 },
      (response) => {
        console.log("API Response:", response);

        // Check if response succeeded and has data
        if (response?.succeeded && response.data?.length > 0) {
          const latestRecord = response.data[0];
          console.log("Latest Record:", latestRecord);

          setFormData({
            rawMaterialId: data.rawMaterialId,
            quantityToReduce: latestRecord.quantity || 0,
            reason: latestRecord.reason || "",
          });
        } else {
          setFormData({
            rawMaterialId: data.rawMaterialId,
            quantityToReduce: 0,
            reason: "",
          });
        }
      }
    );
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          // backgroundColor: "white",
          // width: { xs: "90%", md: "50%" },
          // maxHeight: "90vh",
          // overflowY: "auto",
          // position: "absolute",
          // left: "50%",
          // top: "15%",
          // transform: "translateX(-50%)",
          // borderRadius: 2,
          // boxShadow: 24,
          // p: 3,
          background: "white",
          width: { xs: "90%", md: "50%", sm:"40%" },
          overflowY: "auto",
          maxHeight: "90vh",
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "5%", sm: "25%", md: "25%" },
          top: "15%",
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
        }}
      >
        {/* <ModalHeader title="Reduce Stock" onClose={() => setOpen(false)} /> */}
        <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: { xs: "12px", sm: "13px", md: "15px" },

            // p: "0px 10px !important",
          }}
        >
          Reduce Stock{" "}
          <CloseIcon
            sx={{
              float: "right",
              cursor: "pointer",
              fontSize: { xs: "15px", sm: "15px", md: "16px" },
            }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle>

        <Divider
          sx={{
            borderColor: "#01008B",
            borderWidth: "1px",
            mx: "auto",
            width: "94%",
          }}
        />
        <Grid container spacing={2} sx={{ p: 3 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Quantity to Reduce"
                name="quantityToReduce"
                size="small"
                value={
                  formData.quantityToReduce !== 0
                    ? formData.quantityToReduce
                    : ""
                }
                onChange={(e) => {
                  let val = e.target.value;
                  // Allow only digits and optional one decimal point
                  val = val.replace(/[^0-9.]/g, "");

                  // Prevent multiple decimals
                  if ((val.match(/\./g) || []).length > 1) return;

                  setFormData((prev) => ({
                    ...prev,
                    quantityToReduce: val ? parseFloat(val) : "",
                  }));
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#01008B",
                      borderWidth: "2px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#01008B",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#01008B",
                    },
                  },
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                inputProps={{ inputMode: "decimal" }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Reason"
                name="reason"
                size="small"
                value={formData.reason}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#01008B", // Default border
                      borderWidth: "2px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#01008B", // On hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#01008B", // On focus
                    },
                  },
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
                onChange={handleChange}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{
                  style: {
                    // height: '40px',
                    // background:"yellow"
                  },
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{
                paddingX: { xs: "70px", sm: "60px" },
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Reduce Stock
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
